import React from "react";
import { useFlags } from "launchdarkly-react-client-sdk";

import { styled, useTheme } from "@mui/material/styles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import pxToRem from "libs/pxToRem";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import ListSubheader from "@mui/material/ListSubheader";

import Switch from "@mui/material/Switch";
import BuildRoundedIcon from "@mui/icons-material/BuildRounded";

const StyledList = styled(List)(({ theme }) => ({
  width: "100%",
  boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.16)",
  borderRadius: pxToRem(12),
  backgroundColor: theme.palette.background.paper,
}));

const BoldListItemText = styled(ListItemText)({
  "& .MuiListItemText-primary": {
    fontWeight: 600,
  },
});

const DevInfo = () => {
  const { betaMode } = useFlags();
  const theme = useTheme();

  return (
    <>
      <ListSubheader>DEV INFO</ListSubheader>
      <StyledList as="nav" style={{ padding: 0 }}>
        <ListItem>
          <ListItemIcon style={{ minWidth: 0, paddingRight: 16 }}>
            <BuildRoundedIcon
              style={{
                color: theme.palette.primary.main,
              }}
            />
          </ListItemIcon>
          <BoldListItemText id="isBetaMode" primary="Is Beta Mode" />
          <ListItemSecondaryAction>
            <Switch
              edge="end"
              disableRipple={true}
              disableFocusRipple={true}
              disableTouchRipple={true}
              checked={betaMode ? true : false}
              inputProps={{ "aria-labelledby": "isBetaMode" }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      </StyledList>
    </>
  );
};

export default DevInfo;
